import localforage from "localforage";

localforage.config({
  name: "NextgenFieldworkStorage",
  storeName: "nextgenFieldworkData",
  driver: localforage.INDEXEDDB,
});

export async function fetchWithCache(key, fetcher) {
  try {
    const cachedData = await localforage.getItem(key);
    if (cachedData) {
      return cachedData;
    }

    const response = await fetcher();
    await localforage.setItem(key, response.data);
    return response.data;
  } catch (error) {
    console.error(`Failed to get ${key} data :`, error);
    throw error;
  }
}

export async function fetchTemplateWithCache(key, fetcher, formId) {
  try {
    const templatesMap = await localforage.getItem(key);
    if (templatesMap && templatesMap[formId]) {
      return templatesMap[formId];
    }

    const response = await fetcher();
    const updatedMap = {
      ...templatesMap,
      [formId]: response.data,
    };
    await localforage.setItem(key, updatedMap);
    return response.data;
  } catch (error) {
    console.error(`Failed to get ${key} data :`, error);
    throw error;
  }
}

export async function invalidateTemplateFromCache(key, formId) {
  try {
    const templatesMap = await localforage.getItem(key);
    if (templatesMap && templatesMap[formId]) {
      delete templatesMap[formId];
      await localforage.setItem(key, templatesMap);
    } else {
      console.log(`No cache found for formId ${formId}`);
    }
  } catch (error) {
    console.error(`Failed to invalidate formId ${formId} :`, error);
    throw error;
  }
}

export async function mutateAndRefresh(key, mutationFn, fetchFn) {
  try {
    const result = await mutationFn();
    await invalidateCache(key);
    await fetchFn();
    return result;
  } catch (error) {
    console.error(`Failed to mutate and refresh for key ${key}:`, error);
    throw error;
  }
}

export async function invalidateCache(key) {
  await localforage.removeItem(key);
}

export async function clearCache() {
  await localforage.clear();
}
